/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type BasicCustomerDataTwoFactorMethod =
  (typeof BasicCustomerDataTwoFactorMethod)[keyof typeof BasicCustomerDataTwoFactorMethod];

export const BasicCustomerDataTwoFactorMethod = {
  SMS: "SMS",
  APP: "APP",
  STANDARD: "STANDARD",
} as const;
